// SectionFilter.jsx — reusable section filter dropdown, driven by the items'
// sectionNo/sectionName. `value` is a section key, "All", or "__none__".
// Renders nothing when the project has no sections, so it's safe to drop into
// any module's toolbar unconditionally.

import React from "react";
import { getProjectSections } from "../utils/sections";

export default function SectionFilter({
  items = [],
  value = "All",
  onChange,
  includeUnsectioned = true,
  style,
}) {
  const sections = getProjectSections(items);
  if (!sections.length) return null;
  return (
    <select
      value={value}
      onChange={(e) => onChange && onChange(e.target.value)}
      title="Filter by section"
      style={{
        padding: "6px 10px",
        borderRadius: 8,
        border: "1px solid #d1d5db",
        background: "#fff",
        fontSize: 13,
        color: "#0f172a",
        ...style,
      }}
    >
      <option value="All">All sections</option>
      {sections.map((s) => (
        <option key={s.key} value={s.key}>{s.label}</option>
      ))}
      {includeUnsectioned && <option value="__none__">Unsectioned</option>}
    </select>
  );
}
